import smallHeaderImage from '../assets/hotspot/headerImages/claudia-s.jpg';
import largeHeaderImage from '../assets/hotspot/headerImages/claudia-l.jpg';
import introImage from '../assets/hotspot/intro/Meet_Claudia.jpg.jpeg';
import postcard from '../assets/hotspot/postcardPdf/ClaudiaPostcard.pdf';
import postcardThumbnail from '../assets/hotspot/postcardImages/ClaudiaPostcardThumbnail.jpg';
import concertThumbnail from '../assets/hotspot/celebrationPerformances/Claudia_concert.jpg.jpeg';

export const claudia = {
  name: 'Claudia',
  headerImages: [smallHeaderImage, largeHeaderImage],
  introVideo: {
    headline: 'Meet Claudia, who sings Chilean folk music!',
    details: '',
    vimeoLink: 'https://vimeo.com/1105186919?fl=pl&fe=sh',
    videoImage: introImage,
  },
  concertVideo: {
    videoLink: 'https://vimeo.com/1105183423?fl=pl&fe=sh',
    videoImage: concertThumbnail,
  },
  exploreLink: 'https://www.carnegiehall.org/Education/Programs/Musical-Explorers/Digital/Artists/Claudia',
  postCard: {
    pdf: postcard,
    thumbnail: postcardThumbnail,
  },
  lessons: [
    {
      id: 1,
      type: 'audio',
      headline: 'Listen to Claudia Sing "Gracias a la Vida"',
      link: 'Learn "Gracias a la Vida"',
      linkUrl: 'https://www.carnegiehall.org/Education/Programs/Musical-Explorers/Digital/Artists/Claudia/Lesson-1',
      soundcloudEmbed: '<iframe width="100%" height="166" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/soundcloud%253Atracks%253A2137989627&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"></iframe>',
    },
    {
      id: 2,
      type: 'audio',
      headline: 'Listen to Claudia Sing "El Derecho de Vivir en Paz"',
      link: 'Learn "El Derecho de Vivir en Paz"',
      linkUrl: 'https://www.carnegiehall.org/Education/Programs/Musical-Explorers/Digital/Artists/Claudia/Lesson-2',
      soundcloudEmbed: '<iframe width="100%" height="166" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/soundcloud%253Atracks%253A2137996794&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"></iframe>',
    },
  ],
  traditionBlurb: 'Chilean folk music reflects the diverse geography and cultural heritage of Chile, from the Andean highlands to the coastal regions. It often features themes of social justice, love for the land, and the struggles of everyday people, with instruments like the guitar, charango, and quena.',
  celebrationVideos: [
    {
      videoLink: 'https://vimeo.com/1105183423?fl=pl&fe=vl',
      videoImage: concertThumbnail,
      songTitle: 'Gracias a la Vida',
      artistName: 'Claudia',
      videoTags: [
        {
          tag: 'Día de los Muertos',
        },
      ],
      songDescription: '"Gracias a la Vida" ("Thanks to Life") is an important part of Chilean culture, traditionally performed at various types of celebrations, ceremonies, and events. The song\'s role in Chilean life goes beyond entertainment—it helps bring people together to honor important moments in their communities and their roots.',
    },
    {
      videoLink: 'https://vimeo.com/1105182774?fl=pl&fe=vl',
      videoImage: concertThumbnail,
      songTitle: 'El Derecho de Vivir en Paz',
      artistName: 'Claudia',
      videoTags: [
        {
          tag: 'Chile Independence Day',
        },
      ],
      songDescription: '"El Derecho de Vivir en Paz" ("The Right to Live in Peace") is a famous Chilean song that shares a message of peace, kindness, and fairness for all people. The song has become an important symbol of hope and unity for people around the world.',
    },
  ],
};
